import React from "react";
import { UserPage } from "../../../components/admin/UserPage";

export function AdminUserRoute() {
  return <UserPage />;
}
